import LocationCityIcon from '@mui/icons-material/LocationCity';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MessageIcon from '@mui/icons-material/Message';
import PeopleIcon from '@mui/icons-material/People';
import FolderIcon from '@mui/icons-material/Folder';
import { Button } from '@mui/material';
import Header from '../../components/Shared/Header';
import styles from './styles.module.scss';

const emergencyPreparednessLinks = [
  {
    onClick: () =>
      window.open(
        `https://drive.google.com/drive/folders/176rLt0s-IocPoR8CPBYRuyU1gHKHlTSE`,
        '_blank'
      ),
    name: 'Emergency Preparedness Documents',
    icon: <FolderIcon />,
    href: `https://drive.google.com/drive/folders/176rLt0s-IocPoR8CPBYRuyU1gHKHlTSE`,
  },
  {
    onClick: () =>
      window.open(
        `https://beready.utah.gov/family-preparedness/12-areas-of-preparedness/important-documents-money/`,
        '_blank'
      ),
    name: 'beready.utah.gov',
    icon: <LocationCityIcon />,
    href: `https://beready.utah.gov/family-preparedness/12-areas-of-preparedness/important-documents-money/`,
  },
  {
    onClick: () =>
      window.open(
        `https://providentliving.churchofjesuschrist.org/food-storage/home-storage-center-locations-map?lang=eng`,
        '_blank'
      ),
    name: 'Home Storage Center Locations',
    icon: <LocationOnIcon />,
    href: 'https://providentliving.churchofjesuschrist.org/food-storage/home-storage-center-locations-map?lang=eng',
  },
  {
    onClick: () =>
      window.open(
        `https://www.churchofjesuschrist.org/study/general-conference/2020/10/25waddell?lang=eng`,
        '_blank'
      ),
    name: 'There Was Bread',
    icon: <MessageIcon />,
    href: `https://www.churchofjesuschrist.org/study/general-conference/2020/10/25waddell?lang=eng`,
  },
];

const EmergencyPreparedness = () => {
  const handleDownload = async () => {
    const response = await fetch('/files/peace-in-preparedness.pdf');
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'peace-in-preparedness.pdf';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className={styles.container}>
      <div className={styles.heroBanner}>
        <img
          src='/images/emergency-preparedness-supplies.webp'
          alt='Emergency Preparedness Folder'
          className={styles.heroImage}
        />
      </div>
      <Header
        title='Emergency Preparedness'
        direction='row'
        type='page'
        underlined
      />
      <p>
        "For many years, Church leaders have urged us to store food and water
        and to have some financial reserves for a time of need. These basic
        steps can make a critical difference in times of personal or widespread
        emergency. Preparation also includes being self reliant through
        education, employment skills, and prudent financial habits. We should
        avoid excessive debt, live within our means, and build savings. When we
        are temporally prepared, we are better able to care for ourselves and
        our families and to help others. Temporal preparedness is not about
        fear. It is about wise planning, personal responsibility, and obedience
        to prophetic counsel.”
      </p>
      <div>- President Dallin H. Oaks</div>

      <div className={styles.emergencyPreparedness}>
        <Header
          type={'section'}
          direction={'row'}
          title={'Helpful Links'}
          underlined
        />
        <div className={styles.emergencyPreparednessLinks}>
          {emergencyPreparednessLinks.map((link, index) => {
            return (
              <div key={index}>
                <Button startIcon={link.icon} onClick={() => link.onClick()}>
                  {link.name}
                </Button>
              </div>
            );
          })}
        </div>

        <div className={styles.howPrepared}>
          <Header
            type={'section'}
            direction={'row'}
            title={'How Prepared Are You For An Emergency?'}
            underlined
          />
          <div className={styles.flyerContainer}>
            <Button
              variant='contained'
              color='primary'
              className={styles.downloadButton}
              onClick={handleDownload}
            >
              Download Flyer (PDF)
            </Button>
            <img
              src='/images/emergency-prep-flyer.png'
              alt='Peace in Preparedness'
              className={styles.flyer}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmergencyPreparedness;
